/**
 * Dashboard Home para Residentes.
 *
 * Vista inicial que muestra información relevante para el residente:
 * - Bienvenida con datos de la unidad
 * - Mensajes de la pizarra
 * - Accesos rápidos a funcionalidades
 */

import React from "react";
import { useSelector } from "react-redux";

import BannerResidente from "./BannerResidente";
import { LinkPrimary } from "jsx/components/CitoPlus/components/CitoPlusLink";
import { Link } from "react-router-dom";

const ResidenteDashboardHome = () => {
  // Obtener datos del usuario desde el store
  const user = useSelector((state) => state.auth.auth?.user);
  const perfilResidente = user?.perfil_residente;

  return (
    <div className="container-fluid">
      {/* Banner promocional */}
      <BannerResidente />

      {/* Header de bienvenida */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="card bg-primary text-white">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="me-3">
                  <i className="fa fa-home fa-3x"></i>
                </div>
                <div>
                  <h2 className="mb-1">
                    ¡Bienvenido, {user?.first_name || "Residente"}!
                  </h2>
                  {perfilResidente?.unidad_residencial && (
                    <p className="mb-0 opacity-75">
                      <i className="fa fa-building me-2"></i>
                      {perfilResidente.unidad_residencial}
                    </p>
                  )}
                  {perfilResidente?.vivienda && (
                    <p className="mb-0 opacity-75">
                      <i className="fa fa-door-open me-2"></i>
                      Unidad: {perfilResidente.vivienda}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Accesos rápidos */}
      <div className="row mb-4">
        <div className="col-12">
          <h4 className="mb-3">Accesos Rápidos</h4>
        </div>

        {/* Card - Visitantes */}
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4">
          <div className="card h-100 hover-shadow">
            <div className="card-body text-center py-4">
              <div className="mb-3">
                <i className="fa fa-users fa-3x text-primary"></i>
              </div>
              <h5 className="card-title">Visitantes</h5>
              <p className="card-text text-muted small">
                Consulta el historial de visitantes
              </p>
              <LinkPrimary to="/visitantes">Ver Visitantes</LinkPrimary>
            </div>
          </div>
        </div>

        {/* Card - Correspondencia */}
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4">
          <div className="card h-100 hover-shadow">
            <div className="card-body text-center py-4">
              <div className="mb-3">
                <i className="fa fa-envelope fa-3x text-success"></i>
              </div>
              <h5 className="card-title">Correspondencia</h5>
              <p className="card-text text-muted small">
                Revisa tu correspondencia pendiente
              </p>
              <LinkPrimary to="/correspondencia">
                Ver Correspondencia
              </LinkPrimary>
            </div>
          </div>
        </div>

        {/* Card - Zonas Sociales */}
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4">
          <div className="card h-100 hover-shadow">
            <div className="card-body text-center py-4">
              <div className="mb-3">
                <i className="fa fa-calendar-alt fa-3x text-warning"></i>
              </div>
              <h5 className="card-title">Zonas Sociales</h5>
              <p className="card-text text-muted small">
                Reserva espacios comunes
              </p>
              <LinkPrimary to="/zonas-sociales">
                Reservar Zona Social
              </LinkPrimary>
            </div>
          </div>
        </div>

        {/* Card - Autorizaciones */}
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4">
          <div className="card h-100 hover-shadow">
            <div className="card-body text-center py-4">
              <div className="mb-3">
                <i className="fa fa-file-signature fa-3x text-info"></i>
              </div>
              <h5 className="card-title">Autorizaciones</h5>
              <p className="card-text text-muted small">
                Crea y consulta autorizaciones
              </p>
              <LinkPrimary to="/autorizacion-crear">
                Nueva Autorización
              </LinkPrimary>
            </div>
          </div>
        </div>
      </div>

      {/* Estilos adicionales */}
      <style>{`
        .hover-shadow {
          transition: all 0.3s ease;
        }
        .hover-shadow:hover {
          transform: translateY(-5px);
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
        }
      `}</style>
    </div>
  );
};

export default ResidenteDashboardHome;
